<template>
  <el-container>
    <el-container>
      <!-- 标题 -->
      <el-header class="pa-0">
        <div class="bg-color-w ht-62 dy-flex jy-c-sb">
          <div :xs="4" class="pl-30 dy-flex jy-c-sb align-i-c">
            <img src="/img/images/dbsx_icon.png" class="wt-40 ht-40" />
            <div class="pl-10 fs-20">{{ $t("common.gzt") }}</div>
          </div>
          <!-- 中英文切换 -->
          <Languageqh v-if="$store.state.sysCs.sfqy_zywqh == '1'"></Languageqh>
        </div>
      </el-header>
      <!-- 内容 -->
      <el-main class="content">
        <!-- 导航 -->
        <div class="pb-20 menuList" v-if="menuData.length > 1">
          <template v-for="(item, index) in menuData">
            <el-dropdown
              trigger="hover"
              placement="bottom-start"
              :key="index"
              v-if="item.sysMenuList.length > 1"
              @command="handleCommand"
            >
              <div
                :key="index"
                :class="
                  activeindex == index
                    ? 'color-primary br-color-primary bw-b-3 br-b-solid '
                    : ''
                "
                class="mx-10 py-10 cursor-p float-l fs-16 color-b"
              >
                {{ item.sysname }}
              </div>
              <template #dropdown>
                <el-dropdown-menu>
                  <template v-for="it in item.sysMenuList">
                    <el-dropdown-item
                      :key="it.qid"
                      @click="setactiveindex(it, item, index)"
                      :command="{ it: it, item: item, index: index }"
                    >
                      <span
                        :class="activeQid === it.qid ? 'color-primary' : ''"
                      >
                        {{ it.qname }}
                      </span>
                    </el-dropdown-item>
                  </template>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
            <div
              v-else
              :key="index"
              :class="
                activeindex == index
                  ? 'color-primary br-color-primary bw-b-3 br-b-solid '
                  : ''
              "
              class="mx-10 py-10 cursor-p float-l"
              @click="setactiveindex(item.sysMenuList[0], item, index)"
            >
              {{ item.sysname }}
            </div>
          </template>
        </div>
        <!-- 页面 -->
        <div class="bg-color-w">
          <div class="loadcss" v-if="loading">
            <LoadingCircleDotGreen :loading="loading"></LoadingCircleDotGreen>
          </div>
          <iframe
            ref="iframe"
            :src="url"
            width="100%"
            :height="frameHeight"
            frameborder="0"
            @load="iframeLoad()"
            :key="url"
          ></iframe>
        </div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import LoadingCircleDotGreen from "@/components/LoadingCircleDotGreen.vue";
import Languageqh from "@/components/Languageqh.vue";

export default {
  name: "dbsx",
  components: { LoadingCircleDotGreen,Languageqh },
  computed: {
    activeSpanStyle() {
      return {
        color: "#66B1FF",
        "font-weight": "500",
      };
    },
    asideStyle() {
      return {
        height: this.$store.state.screenHeight - 133 + "px",
      };
    },
    frameHeight() {
      return this.$store.state.screenHeight - 230 + "px";
    },
  },
  watch: {},
  data() {
    return {
      tableData: [],
      title: "",
      activeindex: 0,
      activeQid: "",
      activQid: "",
      loading: true,
      menuData: [],
      menu: {},
      url: "",
      path: "",
      urlflg: "",
      flg: true,
      collapseArr: [],
    };
  },
  methods: {
    getRowKeys() {
      let key = Math.random();
      return key;
    },
    // 设置悬浮菜单选项展开或折叠
    setCollapse(index) {
      if (this.collapseArr.includes(index)) {
        this.collapseArr.splice(
          this.collapseArr.findIndex((a) => a === index),
          1
        );
      } else {
        this.collapseArr.push(index);
      }
    },
    getOneMenuUrl(item, index) {
      this.activeindex = index.toString();
      if (item.sysMenuList && item.sysMenuList.length > 0) {
        let sys = item.sysMenuList[0];
        this.toSysUrl(sys, item, index.toString());
      } else {
        this.toSysUrl(item, item, index.toString());
      }
    },
    init() {
      this.menuData = this.$route.params.menus;
      if (this.menuData && this.menuData[0] !== "[object Object]") {
        this.$session.setItem("dbsxMenu", JSON.stringify(this.menuData));
      } else {
        this.menuData = JSON.parse(this.$session.getItem("dbsxMenu"));
      }
      if (this.menuData.length > 0 && this.menuData[0].sysMenuList.length > 0) {
        this.toSysUrl(this.menuData[0].sysMenuList[0], this.menuData, 0);
      }
    },
    setactiveindex(item, items, index) {
      this.activeQid = "";
      this.activeindex = index;
      this.toSysUrl(item, items, index);
    },
    // 点击下拉菜单
    handleCommand(com) {
      this.activeQid = com.it.qid;
      this.toSysUrl(com.it, com.item, com.index);
    },
    iframeLoad() {
      this.loading = false;
    },
    toSysUrl(item, items, index) {
      this.loading = true;
      this.activeindex = index.toString();
      this.menu = item;
      yhxx.getNewPageUrl(item).then((res) => {
        this.url = res.data.data;
      });
    },
  },
  beforeMount() {
    window.addEventListener("message", function(evt) {});
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.content {
  max-height: 100%;
}
.menuList {
  flex-direction: row;
  flex-wrap: wrap;
  flex: 1;
  display: flex;
}
.loadcss {
  position: absolute;
  margin-left: 45%;
  margin-top: 200px;
}
.menuItem {
  display: flex;
  align-items: center;
  .rightClick {
    width: 20px;
    height: 20px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      display: none;
    }
  }
}
.menuItem:hover {
  background-color: #d9ecff;
  color: #183d76;
  .rightClick {
    img {
      display: block;
    }
  }
}
.oneMenu {
  font-size: 14px;
  color: #666666;
  width: 140px;
  height: 40px;
  padding: 5px 0px 5px 0px;
  display: flex;
  align-items: center;
}
.oneMenu:hover {
  background-color: #d9ecff;
  // color: #183d76;
}
.twoMenu {
  font-size: 14px;
  color: #666666;
  width: 140px;
  height: 40px;
  padding: 5px 0px 5px 10px;
  display: flex;
  align-items: center;
}
</style>
